import React, { useState } from 'react';
import { Loader2, Mail, Lock } from 'lucide-react';
import BrandLogo from '../components/BrandLogo';
import adminService from '../services/adminService';

export default function Login({ onLoginSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      const data = await adminService.login(email, password);
      onLoginSuccess(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6 font-sans">
      <div className="bg-white w-full max-w-md rounded-xl shadow-xl border border-[#E2E8F0] overflow-hidden">
        <div className="bg-[#0F172A] p-8 text-center">
          <div className="mx-auto mb-4 flex h-20 w-28 items-center justify-center rounded-xl bg-white p-2 shadow-lg">
            <BrandLogo className="h-16 w-24" />
          </div>
          <h1 className="text-white text-sm font-bold uppercase tracking-wider">
            LoversConnect <span className="text-[#D91F26]">MW</span>
          </h1>
          <p className="text-white/40 text-xs font-medium mt-1 uppercase tracking-wider">
            Admin Portal
          </p>
        </div>
        <form onSubmit={handleSubmit} className="p-8 space-y-4">
          <div>
            <label className="text-xs font-medium text-[#94A3B8] uppercase tracking-wider block mb-1.5">
              Email
            </label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
              <input 
                name="email" 
                type="email" 
                placeholder="admin@loversconnectmw.com" 
                required 
                className="w-full pl-10 pr-3 py-2.5 bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D91F26]/20 focus:border-[#D91F26] text-sm font-medium transition-all placeholder:text-[#94A3B8]" 
              />
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-[#94A3B8] uppercase tracking-wider block mb-1.5">
              Password
            </label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
              <input 
                name="password" 
                type="password" 
                placeholder="Enter your password" 
                required 
                className="w-full pl-10 pr-3 py-2.5 bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D91F26]/20 focus:border-[#D91F26] text-sm font-medium transition-all placeholder:text-[#94A3B8]" 
              />
            </div>
          </div>
          <button 
            disabled={loading} 
            className="w-full bg-[#D91F26] text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-all active:scale-[0.98] flex justify-center items-center disabled:cursor-not-allowed disabled:opacity-70 mt-2"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : "Enter Dashboard"}
          </button>
          {error && (
            <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-center text-xs font-semibold text-[#D91F26]">
              {error}
            </div>
          )}
          <p className="text-[10px] text-center text-[#94A3B8] font-medium uppercase tracking-wider">
            Authorized Personnel Only
          </p>
        </form>
      </div>
    </div>
  );
}
